export default __webpack_public_path__ + "media/images/icons/feather-mail-27e3358ea3eed79e42407b5140a4972c.svg";